// 登录逻辑处理
import t from '@/utils/type.js'
import {
  Method_EasySelect
} from '@/utils/loadhttpdata.js';
import api from '@/utils/http.js';
import {
  base_encode,
  base_decode
} from '@/utils/base64.js'

const login = {
  namespaced: true,
  state: {
    staus: '0',
    list: {}
  },
  actions: {
    login_up(context, loaddata) {
      // console.log(loaddata);
      return new Promise((resolve, reject) => {
        // console.log(loaddata);
        if (loaddata.userno == null || loaddata.pwd == null) {
          let t = (localStorage.getItem('userno'));
          if (t == null || t === undefined || t == '') {
            alert('登录信息已经过期,请重新登录!');

            location.href = '/login';

            return;
          } else {
            loaddata.userno = t;
            loaddata.pwd = base_decode(localStorage.getItem('pwd'));
          }
        }
        // console.log('userno='+loaddata.userno+' pwd='+loaddata.pwd);
        api.post(
          t.http_method,
          Method_EasySelect('login', loaddata.userno, loaddata.pwd)
        ).then(res => {
          res = JSON.parse(res);
          // console.log('默认账号',res);
		  console.log('登录反馈22',res.data);
          if (res.data.status == '1') {
            this.state.list = res.data.data;
            localStorage.setItem('userdata', JSON.stringify(res.data.data));
            localStorage.setItem('userno', loaddata.userno);
            localStorage.setItem('pwd', base_encode(loaddata.pwd));
          }
          resolve(res.data)
        });
      })
    }
  }
}

// 最后统一导出
export default login;
